import React from "react";
import { useNavigate } from "react-router-dom";
import { HomeIcon } from "../../../assets";
const TransactionMonthNavigation = () => {
  const navigate = useNavigate();
  return (
    <div className="content-nav">
      <img src={HomeIcon} />
      <span className="content-nav-home">Home</span>
      <i class="bx bx-chevron-right"></i>
      <span className="content-nav-home" onClick={() => navigate(-1)}>
        Transaction-Year
      </span>
      <i class="bx bx-chevron-right"></i>
      <span className="content-nav-home">Transaction-Month</span>
    </div>
  );
};

export default TransactionMonthNavigation;
